import React from 'react';

import * as ht from './_ht';
import * as cr from './_cr';

//import * as gs from './_csGbl';
//import * as ls from './_csLcl';

import * as ica from 'src/ica';

import * as BoxC from './_ccbBoxC';
import * as MdlC from './_csMdl';
import * as LdrC from './_csLdr';

const RootC = React.memo((pz: ht.rootCz) => {

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.rootAbtz[_abtType] ? ica.rootAbtz[_abtType]() : {};

  return (
    cr.c(BoxC.N, {
      key: 'Root.root',
      boxStlz: {
        ... _abtz.boxStlz,
        ... pz.boxStlz,
      },
      oClds: [

        pz.hdrCz ?
        cr.c(BoxC.N, { // hdr
          key: -10,
          ... pz.hdrCz,
          boxStlz: { // dh/hdr を指定要
            ... _abtz.hdrCz?.boxStlz,
            ... pz.hdrCz?.boxStlz,
          },
        })
        : null,

        cr.c(BoxC.N, { // body
          key: -20,
          ... pz.bdyCz,
          boxStlz: { // dh/bdy を指定要
            ... _abtz.bdyCz?.boxStlz,
            ... pz.bdyCz?.boxStlz,
          },
        }),

        pz.ftrCz ?
        cr.c(BoxC.N, { // hdr
          key: -30,
          ... pz.ftrCz,
          boxStlz: {
            ... _abtz.ftrCz?.boxStlz,
            ... pz.ftrCz?.boxStlz,
          },
        })
        : null,

        cr.c(MdlC.N, {
          key: -40,
        }),

        cr.c(LdrC.N, {
          key: -50,
        })

      ]
    })
  )
});
export const N = RootC;
